export class MensalidadeAssociativaModel {
  id?: number;
  lancamentoParcelaId?: number;
  dataReferencia?: any;
  ativo?: boolean;
  usuarioCadastro?: string;
  dataCadastro?: any;
  usuarioAlteracao?: string;
  dataAlteracao?: any;
  lancamentoParcela?: LancamentoParcela;
  grupoFinanceiroId?: number;
  cfcCnpj?: string;

  constructor(options: MensalidadeAssociativaModel = {}) {
    this.id = options.id || null;
    this.lancamentoParcelaId = options.lancamentoParcelaId || null;
    this.dataReferencia = options.dataReferencia || null;
    this.ativo = options.ativo || null;
    this.usuarioCadastro = options.usuarioCadastro || null;
    this.dataCadastro = options.dataCadastro || null;
    this.usuarioAlteracao = options.usuarioAlteracao || null;
    this.dataAlteracao = options.dataAlteracao || null;
    this.lancamentoParcela = options.lancamentoParcela || null;
    this.grupoFinanceiroId = options.grupoFinanceiroId || null;
    this.cfcCnpj = options.cfcCnpj || null;
  }
}

class LancamentoParcela {
  id?: number;
  lancamentoId?: number;
  pessoaId?: number;
  pessoaNome?: string;
  tipoLancamentoId?: number;
  tipoLancamentoDescricao?: string;
  modoPagamentoContaId?: number;
  modoPagamentoContaFormaPagamentoDescricao?: string;
  grupoLancamentoId?: number;
  grupoLancamentoDescricao?: string;
  centroResultadoId?: number;
  centroResultadoDescricao?: string;
  contaCorrenteId?: number;
  contaCorrenteDescricao?: string;
  tipo?: string;
  numeroDocumento?: string;
  valor?: number;
  juros?: number;
  desconto?: number;
  dataEmissao?: any;
  dataPagamento?: any;
  dataBaixa?: any;
  dataVencimento?: any;
  observacao?: string;
  ativo?: boolean;
  usuarioCadastro?: string;
  dataCadastro?: any;
  usuarioAlteracao?: string;
  dataAlteracao?: any;
  cnpjEmpresa?: string;
  lancamentoParcelaCobranca?: LancamentoParcelaCobranca[];

  constructor(options: LancamentoParcela = {}) {
    this.id = options.id || null;
    this.lancamentoId = options.lancamentoId || null;
    this.pessoaId = options.pessoaId || null;
    this.pessoaNome = options.pessoaNome || null;
    this.tipoLancamentoId = options.tipoLancamentoId || null;
    this.tipoLancamentoDescricao = options.tipoLancamentoDescricao || null;
    this.modoPagamentoContaId = options.modoPagamentoContaId || null;
    this.modoPagamentoContaFormaPagamentoDescricao = options.modoPagamentoContaFormaPagamentoDescricao || null;
    this.grupoLancamentoId = options.grupoLancamentoId || null;
    this.grupoLancamentoDescricao = options.grupoLancamentoDescricao || null;
    this.centroResultadoId = options.centroResultadoId || null;
    this.centroResultadoDescricao = options.centroResultadoDescricao || null;
    this.contaCorrenteId = options.contaCorrenteId || null;
    this.contaCorrenteDescricao = options.contaCorrenteDescricao || null;
    this.tipo = options.tipo || null;
    this.numeroDocumento = options.numeroDocumento || null;
    this.valor = options.valor || null;
    this.juros = options.juros || null;
    this.desconto = options.desconto || null;
    this.dataEmissao = options.dataEmissao || null;
    this.dataPagamento = options.dataPagamento || null;
    this.dataBaixa = options.dataBaixa || null;
    this.dataVencimento = options.dataVencimento || null;
    this.observacao = options.observacao || null;
    this.ativo = options.ativo || null;
    this.usuarioCadastro = options.usuarioCadastro || null;
    this.dataCadastro = options.dataCadastro || null;
    this.usuarioAlteracao = options.usuarioAlteracao || null;
    this.dataAlteracao = options.dataAlteracao || null;
    this.cnpjEmpresa = options.cnpjEmpresa || null;
    this.lancamentoParcelaCobranca = options.lancamentoParcelaCobranca || new Array<LancamentoParcelaCobranca>();
  }
}

class LancamentoParcelaCobranca {
  id?: number;
  lancamentoParcelaId?: number;
  formaPagamentoId?: number;
  situacaoCobrancaId?: number;
  numeroCobranca?: number;
  url?: string;
  ativo?: boolean;
  usuarioCadastro?: string;
  dataCadastro?: any;
  usuarioAlteracao?: string;
  dataAlteracao?: any;
  formaPagamento?: FormaPagamento;
  situacaoCobranca?: SituacaoCobranca;

  constructor(options: LancamentoParcelaCobranca = {}) {
    this.id = options.id || null;
    this.lancamentoParcelaId = options.lancamentoParcelaId || null;
    this.formaPagamentoId = options.formaPagamentoId || null;
    this.situacaoCobrancaId = options.situacaoCobrancaId || null;
    this.numeroCobranca = options.numeroCobranca || null;
    this.url = options.url || null;
    this.ativo = options.ativo || null;
    this.usuarioCadastro = options.usuarioCadastro || null;
    this.dataCadastro = options.dataCadastro || null;
    this.usuarioAlteracao = options.usuarioAlteracao || null;
    this.dataAlteracao = options.dataAlteracao || null;
    this.formaPagamento = options.formaPagamento || new FormaPagamento();
    this.situacaoCobranca = options.situacaoCobranca || new SituacaoCobranca();
  }
}

class FormaPagamento {
  id?: number;
  descricao?: string;
  label?: string;
  qtdParcelaMinima?: number;
  qtdParcelaMaxima?: number;
  ativo?: boolean;
  usuarioCadastro?: string;
  dataCadastro?: any;
  usuarioAlteracao?: string;
  dataAlteracao?: any;

  constructor(options: FormaPagamento = {}) {
    this.id = options.id || null;
    this.descricao = options.descricao || null;
    this.label = options.label || null;
    this.qtdParcelaMinima = options.qtdParcelaMinima || null;
    this.qtdParcelaMaxima = options.qtdParcelaMaxima || null;
    this.ativo = options.ativo || null;
    this.usuarioCadastro = options.usuarioCadastro || null;
    this.dataCadastro = options.dataCadastro || null;
    this.usuarioAlteracao = options.usuarioAlteracao || null;
    this.dataAlteracao = options.dataAlteracao || null;
  }
}

class SituacaoCobranca {
  id?: number;
  descricao?: string;
  ativo?: boolean;
  usuarioCadastro?: string;
  dataCadastro?: any;
  constructor(options: SituacaoCobranca = {}) {
    this.id = options.id || null;
    this.descricao = options.descricao || null;
    this.ativo = options.ativo || null;
    this.usuarioCadastro = options.usuarioCadastro || null;
    this.dataCadastro = options.dataCadastro || null;
  }
}
